import React from 'react';
import PropTypes from 'prop-types';

const PhoneField = ({ source, record = {} }) => <span>{record[source] ? addDashes(record[source]): ''}</span>;

function addDashes(phone) {
  const phones = phone.split(',')
  for (let _phone in phones) {
    phones[_phone].replace(/\D/g,'')
    phones[_phone] =  phones[_phone].substring(0, 3) + '-' + phones[_phone].substring(3, 6) + '-' + phones[_phone].substring(6, 10)

  }
  
  return phones.toString().split(',').join('\n')
}

PhoneField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

PhoneField.defaultProps = {
  addLabel: true,
};

export default PhoneField;
